module.exports = __webpack_public_path__ + "static/media/luntan1.6fc69de3.jpg";